export default {
	_mastheadTitle: false,
	init() {
		this._mastheadTitle = document.querySelector('[data-masthead-title]');
		if (this._mastheadTitle) {
			this.adjust(this._mastheadTitle, 24);
		}
	},
	reload() {

	},
	_postProcess(title) {
		title.removeAttribute('data-dynamic-font-size');
		title.style.display = 'block';
	},
	adjust(container, minimum) {
		if (!container) {
			return;
		}
		const title = container.querySelector('[data-dynamic-font-size]');
		if (!title) {
			return;
		}
		const minimumFontSize = minimum || 16;
		let fontSize;
		const clonedContainer              = container.cloneNode(true);
		clonedContainer.style.visibility = 'visible';
		clonedContainer.style.opacity    = '1';
		clonedContainer.style.transform  = 'none';
		container.parentNode.appendChild(clonedContainer);
		const clonedTitle = clonedContainer.querySelector('[data-dynamic-font-size]');
		const parentRect  = clonedTitle.parentNode.getBoundingClientRect();
		const parentWidth = parentRect.width;
		let actualWidth = clonedTitle.scrollWidth;
		if (parentWidth > actualWidth) {
			container.parentNode.removeChild(clonedContainer);
			this._postProcess(title);
			return;
		}
		const styles = window.getComputedStyle(clonedTitle, null);
		fontSize   = parseFloat(styles.getPropertyValue('font-size'));
		while (actualWidth > parentWidth && fontSize > minimumFontSize) {
			clonedTitle.style.fontSize = --fontSize + 'px';
			actualWidth                = clonedTitle.scrollWidth;
		}
		if (fontSize) {
			title.style.fontSize = fontSize + 'px';
		}
		container.parentNode.removeChild(clonedContainer);
		this._postProcess(title);
	}
};